import { Tooltip } from "@mui/material";
import makeStyles from "styles/muiStylesCompat/makeStyles";
import LocalTaxiIcon from "@mui/icons-material/LocalTaxi";

const useStyles = makeStyles((theme) => ({
  icon: {
    width: (props) => props.size,
    height: (props) => props.size,
    fontSize: (props) => props.size / 2,
    transform: "translate(-50%, -100%)",
    //position: relative,
    //bottom: props => props.size / 2,
    cursor: "pointer",
    color: (props) =>
      props?.color ? props?.color : theme.palette.primary.main,
    backgroundColor: (props) =>
      props?.backgroundColor ? props?.backgroundColor : "#FFF",
    opacity: (props) => (props?.opacity ? props?.opacity : 1),
    borderWidth: (_props) => "1px",
    borderStyle: "solid",
    borderColor: (props) =>
      props?.borderColor ? props?.borderColor : theme.palette.primary.main,
    borderRadius: "50%",
  },
  iconHover: {
    // width: 42,
    // height: 42,
    // transform: 'translate(-50%, -100%)',
    cursor: "pointer",
  },
  title: {
    textAlign: "center",
    // transform: 'translate(-100%, -100%)'
  },
}));

const MapPin = (props) => {
  const { title, hoverDisabled, pinContent, onClick } = props;
  const classes = useStyles(props);

  return (
    <div>
      <Tooltip
        title={title || ""}
        placement="top"
        disableHoverListener={hoverDisabled}
      >
        <LocalTaxiIcon className={classes.icon} onClick={onClick}>
          {pinContent}
        </LocalTaxiIcon>
      </Tooltip>
    </div>
  );
};

export default MapPin;
